var map = {
	"./ball10.png": "qEKK",
	"./ball20.png": "NRRD",
	"./ball5_new.png": "zbRb",
	"./ball8.png": "uiNM",
	"./banner-bg.jpg": "tTqm",
	"./foot1.png": "5Bgi",
	"./foot2.png": "g51r",
	"./foot3.png": "rgIK",
	"./foot4.png": "p1lw",
	"./foot5.png": "ydwP",
	"./go_top.png": "HcqT",
	"./help-banner_new.png": "Vw+E",
	"./keno-banner_new.jpg": "Sc5I",
	"./logo.png": "iQH9",
	"./ppt-1.jpg": "Po2S",
	"./ppt-2.jpg": "QQRK",
	"./ppt-3.jpg": "Ie2v",
	"./ppt-page.jpg": "Ejph",
	"./responsible_glogo.png": "zOrK",
	"./responsible_logo.png": "OvWg",
	"./results-banner_new.jpg": "33wH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1